export default __webpack_public_path__ + "static/media/TiemposFineWeb-Light.3b9c24cb.woff";